import React from 'react';
import PropTypes from 'prop-types';

import { Dialog } from '../../../../../../../../../../components/Dialog';
import { DialogHeader } from '../../../../../../../../../../components/DialogHeader';
import { DialogBody } from '../../../../../../../../../../components/DialogBody';
import { DialogFooter } from '../../../../../../../../../../components/DialogFooter';

export const ConstraintTypeModal = ({ header, id, children, closeDialog }) => {
    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    return (
        <Dialog close={CloseDialog} size="lg" visible id={id}>
            <DialogHeader close={CloseDialog}>{header}</DialogHeader>
            <DialogBody>{children}</DialogBody>
            <DialogFooter />
        </Dialog>
    );
};

ConstraintTypeModal.propTypes = {
    header: PropTypes.string.isRequired,
    children: PropTypes.node,
    id: PropTypes.string,
    closeDialog: PropTypes.func.isRequired
};

export default ConstraintTypeModal;
